import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const handlers = new WeakMap()
const wrappers = new WeakMap()

const onInput = object(listener, {
  type: input,
  passive,
  task: async element => {
    const wrapper = wrappers.get(element)

    await handlers.get(element)?.(element, wrapper)
  }
})

const onClick = object(listener, {
  type: click,
  passive,
  task: async button => {
    const wrapper = wrappers.get(button)

    await handlers.get(button)?.(button, wrapper)
  }
})

export const handle = (element, handler) => {
  const wrapper = closest(`[data-contract*="event.addEdit.repeat.frequency.wrapper"]`, element)

  if (!wrappers.has(wrapper)) {
    return
  }

  wrappers.set(element, wrapper)
  handlers.set(element, handler)
  
  if (element.type === 'button') {
    onClick.listen(element)
  } else {
    onInput.listen(element)
  }

  queueMicrotask(async () => {
    await removed(element)
    handlers.delete(element)
    wrappers.delete(element)
  })
}

export default wrapper => {
  wrappers.set(wrapper, wrapper)

  queueMicrotask(async () => {
    await removed(wrapper)
    wrappers.delete(wrapper)
  })
}
